import { Descriptions, Typography } from "antd";
import { currencyFormat } from "./PartnerViewTable";

const { Text } = Typography;

type TfsPartnerViewProps = {
  calculationResult: any;
  selectedMonth: any;
  partnerView: any;
};

export const TfsPartnerView = ({
  calculationResult,
  selectedMonth,
  partnerView,
}: TfsPartnerViewProps) => {
  return (
    <Descriptions
      bordered
      size="small"
      column={1}
      labelStyle={{ width: "40%", fontWeight: 600, backgroundColor: "#fbfcfd", color: "#475569", fontSize: "12px" }}
      contentStyle={{ backgroundColor: "#fff", fontSize: "13px", fontWeight: 500, color: "#1e293b" }}
    >
      <Descriptions.Item label="Suggested Retail Price (SRP)">
        {currencyFormat(calculationResult.unit_price)}
      </Descriptions.Item>
      <Descriptions.Item label={"Months to Pay"}>
        {selectedMonth.months_to_pay}
      </Descriptions.Item>
      <Descriptions.Item label="Downpayment">
        {currencyFormat(calculationResult.downpayment)}
      </Descriptions.Item>
      <Descriptions.Item label="Amount Financed Percentage Rate">
        {partnerView.financed_amount_percentage}
      </Descriptions.Item>
      <Descriptions.Item label="Loan Amount">
        {partnerView.loan_amount_all_in}
      </Descriptions.Item>
      <Descriptions.Item label="Monthly Interest Rate">
        {(selectedMonth.interest_value * 100).toFixed(2)}%
      </Descriptions.Item>
      <Descriptions.Item label="Total Interest Multiplier">
        {partnerView.total_interest_multiplier}
      </Descriptions.Item>
      <Descriptions.Item label="Applied Interest Amount">
        {currencyFormat(partnerView.applied_interest_multiplier)}
      </Descriptions.Item>
      <Descriptions.Item label={<span style={{ fontWeight: 700 }}>Monthly</span>}>
        {currencyFormat(selectedMonth.monthly_amount)}
      </Descriptions.Item>
    </Descriptions>
  );
};
